export default __webpack_public_path__ + "static/events-in-posthog-dark-550765319ebbc8288553d8e312eb3a4a.png";